import {IconDefinition} from "@fortawesome/fontawesome-common-types";
import {faAward, faBook, faCircleCheck, faPeopleGroup} from "@fortawesome/free-solid-svg-icons";
import {faEye} from "@fortawesome/free-regular-svg-icons";
import {faBell, faBrain, faChevronRight, faCircleInfo, faMagnifyingGlass, faNewspaper} from "@fortawesome/pro-solid-svg-icons";

export const availableLearnIcons: {[key: string]: IconDefinition} = {
  'book': faBook,
  'award': faAward,
  'eye': faEye,
  'group': faPeopleGroup,
  'peoplegroup': faPeopleGroup,
  'bell': faBell,
  'brain': faBrain,
  'newspaper': faNewspaper,
  'magnifyingglass': faMagnifyingGlass,
  'search': faMagnifyingGlass,
  'circlecheck': faCircleCheck,
  'circleinfo': faCircleInfo,
  'chevronright': faChevronRight,
}